'use client'

import { Typo3SectionPowermailPi1 } from '@/types/typo3/sections/powermail'
import dynamic from 'next/dynamic'
import { Suspense, memo } from 'react'

const PowermailPi1Form = dynamic(() => import('./PowermailPi1Form'), {
  ssr: false
})

interface Props {
  data: Typo3SectionPowermailPi1
}

const PowermailPi1 = ({ data }: Props) => (
  <Suspense>
    <PowermailPi1Form data={data} />
  </Suspense>
)

PowermailPi1.displayName = 'PowermailPi1'

export default memo(PowermailPi1)
